import { useGetFrontTipiDomandaAree } from '@framework/api-client/api/inquiries-compile/domande-controller/domande-controller.ts';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IInquiryAreaSelectInputProps {
  name: string;
}

export function InquiryAreaSelectInput(props: IInquiryAreaSelectInputProps) {
  const { name } = props;
  const { t } = useTranslation();
  const aooTypesResult = useGetFrontTipiDomandaAree();
  const { data, isLoading, error } = aooTypesResult;

  const options = useMemo(() => {
    return data?.map(area => ({
      label: [area.idArea, area.denominazione].filter(Boolean).join(' - '),
      value: area.idArea!,
    }));
  }, [data]);

  return (
    <SelectInput
      allowClear
      optionFilterProp="label"
      showSearch
      style={{ width: '100%' }}
      loading={isLoading}
      name={name}
      placeholder={t('inquiry.area-filter', 'Amministrazione')}
      options={options}
    />
  );
}
